import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import Grid from '../../../../grid/Grid';

class BeaufortDetailedBill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { bill, } = this.props;
    const paymentTransactions = ObjectUtils.formatStringAsJSONArray(bill.paymentTransactions);
    const paymentModel = Grid.toModelFromList(paymentTransactions);
    const installments = ObjectUtils.formatStringAsJSONArray(bill.installments);
    const installmentModel = Grid.toModelFromList(installments);

    const items = VerticalLabelList.toList({
      Id: bill.id,
      'Due date': bill.dueDate,
      Paid: bill.isPaid,
      'Tax Year': bill.taxYear,
      'Bill Balance': bill.billBalance_value,
      'Bill Amount': bill.billAmount_value,
      'Client Bill Balance': bill.clientBillBalance_value,
      'PayIt Balance': bill.payitBillBalance_value,
      'Created on': moment(bill.createdOn)
        .utc()
        .format(),
      'Updated at': moment(bill.updatedAt)
        .utc()
        .format(),
      'Rev Obj Id': bill.revObjId,
      'Bill Number': bill.billNumber,
      'External Bill Id': bill.externalBillId,
      'Account Id': bill.accountId,
      'Cad Owner Id': bill.cadOwner,
      'Tax Ratio': bill.taxRatio,
      'Assessment Ratio': bill.assessmentRatio,
      'New Notification Enabled': bill.newNotificationEnabled,
      'Overdue Notification Enabled': bill.overdueNotificationEnabled,
      'Last Day To Pay Notification Enabled': bill.lastDayToPayNotificationEnabled,
    });

    return (
      <div>
        <div>
          <FieldSet title="Tax Accounts" style={{ maxHeight: '400px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Payment Transactions" style={{ maxHeight: '300px', }}>
            <Grid headers={paymentModel.headers} rows={paymentModel.format(paymentTransactions)} />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Installments" style={{ maxHeight: '300px', }}>
            <Grid headers={installmentModel.headers} rows={installmentModel.format(installments)} />
          </FieldSet>
        </div>
      </div>
    );
  }
}

BeaufortDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default BeaufortDetailedBill;
